import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Link, Redirect, Route, Switch } from "react-router-dom";
import { InfoDiagnostic2ReportApi } from "src/services/Api/Organization/types";
import Header from "go-app/components/Header";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import IndexedDb from "go-core/utils/IndexedDb";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { apiOrganization } from "../../../../../../../../services/Api/Organization/apiOrganization";
import OrganizationSettingsDiagnostic2LayersPage from "./Layers";
import OrganizationSettingsDiagnostic2ReportStatesPage from "./ReportStates";

const storageKey = "diagnostic_info";
const OrganizationSettingsDiagnostic2Page: FC<RouteComponentProps> = (props) => {
	const [loading, setLoading] = useState<boolean>(true);
	const [updatedTime, setUpdatedTime] = useState<number | undefined>(undefined);
	const [info, setInfo] = useState<InfoDiagnostic2ReportApi | undefined>(undefined);
	const organization = useSelector(selectOrganization);
	const dbName = `organization_${organization.id}`;
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle("Narzędzia diagnostyczne");
		fetch();
	}, []);

	const fetch = async () => {
		const diagnosticDataStorage = await IndexedDb.retrieveDataFromIndexedDB(dbName, storageKey, storageKey);

		if (diagnosticDataStorage) {
			const { data, timestamp } = JSON.parse(diagnosticDataStorage);
			const currentTime = new Date().getTime();
			if (currentTime - timestamp <= 900000) {
				setUpdatedTime(timestamp);
				setInfo(data);
				setLoading(false);
				return;
			}
		}

		await refreshData();
	};

	const refreshData = async () => {
		setLoading(true);
		const data = await apiOrganization.getDiagnostic2Info({});
		setInfo(data);
		setLoading(false);
		const timestamp = new Date().getTime();
		setUpdatedTime(timestamp);
		IndexedDb.storeDataInIndexedDB(dbName, storageKey, storageKey, JSON.stringify({ data, timestamp }));
	};

	const currentTime = new Date();
	let diffTimeValue: string | undefined = undefined;
	if (updatedTime) {
		const timeDifference = currentTime.getTime() - updatedTime;

		// Calculate minutes and seconds
		const minutes = Math.floor(timeDifference / (1000 * 60));
		const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
		diffTimeValue = `${minutes} min, ${seconds} seconds`;
	}

	return (
		<div className="content">
			<Header title={"Narzędzia diagnostyczne"} />
			{loading ? (
				<LoadingContainer />
			) : (
				<>
					<div>
						<Link to={`${props.match.url}`}>Główna</Link>
						{updatedTime && (
							<p>
								Dane pobrane: {new Date(updatedTime).toISOString()} ({diffTimeValue} temu)
							</p>
						)}
						<button className={"btn btn-sm btn-default"} onClick={refreshData}>
							Odśwież dane
						</button>
					</div>
					{/*<SubmenuDiagnosticNavigation />*/}

					<Switch>
						<Route
							path={`${props.match.url}/report`}
							render={(props) => {
								return <OrganizationSettingsDiagnostic2ReportStatesPage data={info} />;
							}}
							// component={OrganizationSettingsDiagnostic2ReportStatesPage}
						/>
						<Route
							path={`${props.match.url}/layers`}
							render={(props) => {
								return <OrganizationSettingsDiagnostic2LayersPage data={info} />;
							}}
							// component={OrganizationSettingsDiagnostic2ReportStatesPage}
						/>
						{/*<Route*/}
						{/* path={`${props.match.url}/product/open-amount`}*/}
						{/* component={OrganizationSettingsDiagnosticProductOpenAmountPage}*/}
						{/*/>*/}
						{/*<Route*/}
						{/* path={`${props.match.url}/product/transactions`}*/}
						{/* component={OrganizationSettingsDiagnosticProductTransactionsPage}*/}
						{/*/>*/}
						<Redirect from={props.match.url} exact to={`${props.match.url}/report`} />
					</Switch>
				</>
			)}
		</div>
	);
};

export default OrganizationSettingsDiagnostic2Page;
